export const REGEXP_ONLY_DIGITS: RegExp = /\d+/g;

export const REGEXP_EXCLUDE_DIGITS: RegExp = /\D+/g;

export const REGEXP_TICKET_DESCRIPTION: RegExp = /[a-zA-Z][\w.]+|[^a-zA-Z]+/g;
